// extracted by mini-css-extract-plugin
export default {"templateDrawer":"useMenuItemContent_templateDrawer__+Xclg","closeDark":"useMenuItemContent_closeDark__a5Ip7"};